import Button, { BUTTON_KIND } from '@/components/Button';
import Modal from '@/components/Modals/Modal';

interface PurchasingAdditionalCardModalProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

export default function PurchasingAdditionalCardModal(
  props: PurchasingAdditionalCardModalProps,
) {
  const { isOpen, setIsOpen } = props;
  const shopUrl =
    (import.meta.env.VITE_SHOP_BASE_URL as string) || 'https://tapt.test:3001';

  const bulletPoints = [
    'The fee only applies to organisations with 5+ cards or profiles.',
    "It's charged annually and depends on the total number of profiles.",
    'If you add more profiles during the year, the fee may change on a pro-rata basis.',
  ];

  return (
    <Modal
      isOpen={isOpen}
      dialogTitle="Platform Fee &amp; Pricing"
      cancelButtonText="Close"
      successButtonText="Learn more about the platform fee"
      successButton={
        <Button
          kind={BUTTON_KIND.PRIMARY}
          buttonText="Learn more about the platform fee"
          external
          externalBlankTarget
          href={`${shopUrl}/pages/pricing`}
        />
      }
      onSuccess={() => setIsOpen(false)}
      onCancel={() => setIsOpen(false)}
      onClose={() => setIsOpen(false)}
    >
      <div className="space-y-6">
        <div className="leading-5 text-sm text-gray-600 pt-3">
          Tapt&apos;s platform fee helps us keep improving our software,
          features and analytics.
        </div>

        <ul className="list-disc pl-5">
          {bulletPoints.map((point, index) => (
            <li key={index} className="text-sm text-gray-600 leading-5">
              {point}
            </li>
          ))}
        </ul>

        <div className="leading-5 text-sm text-gray-600">
          Click below to learn more about our platform fee and pricing.
        </div>
      </div>
    </Modal>
  );
}
